export default (mainPromise, subPromise) => {
  return mainPromise.finally(() => {
    if (subPromise && subPromise.then && subPromise.isPending()) {
      subPromise.cancel();
    }
  });
};
